import React from 'react';
import NiceicDownloadButton from './niceic_download_button';

class NiceicPocketGuidesTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.renderDownloadTable = this.renderDownloadTable.bind(this);
    this.renderDownloadLinks = this.renderDownloadLinks.bind(this);
  }

  renderDownloadTable() {
    const { pocketGuides, selectAllChecked, selectedCount, handleClearAll } =
      this.props;

    if (!pocketGuides.length) {
      return (
        <div className="pocket-guides__table">
          <p>
            Sorry pocket guides are unavailable at the moment, refresh the page
            to try again.
          </p>
        </div>
      );
    }

    return (
      <div className="pocket-guides__table">
        <div className="fl">
          <label className="pocket-guides__select-all-label">
            <input
              className="pocket-guides__table-checkbox"
              type="checkbox"
              onChange={e => this.props.handleSelectAll(e)}
              checked={selectAllChecked}
            />
            {selectedCount === 0 ? (
              'Select all'
            ) : (
              <span>
                {selectedCount === pocketGuides.length ? 'All' : selectedCount}{' '}
                Selected
              </span>
            )}
          </label>
          {selectedCount > 0 && (
            <button
              className="pocket-guides__clear-all"
              onClick={handleClearAll}>
              Clear
            </button>
          )}
        </div>
        <ul className="pocket-guides__list">
          {pocketGuides.map((value, index) => {
            const { title, checked } = value;
            return (
              <li key={index}>
                <label className="pocket-guides__table-label fl ai-c">
                  <input
                    className="pocket-guides__table-checkbox"
                    type="checkbox"
                    onChange={e => this.props.handleSelectOne(e, index)}
                    checked={checked || false}
                  />
                  {title}
                </label>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  renderDownloadLinks() {
    const { filteredGuides } = this.props;

    return (
      <div className="pocket-guides__table">
        <ul className="pocket-guides__list">
          {filteredGuides.map((value, index) => {
            const { title, url } = value;
            return (
              <li className="fl ai-c jc-sb" key={index}>
                <div>
                  <a
                    href={url}
                    target="_blank"
                    className="pocket-guides__table-label pocket-guides__table-label--large"
                    rel="noreferrer">
                    {title}
                  </a>
                </div>
                <div className="pocket-guides__date-cell">
                  <a
                    href={url}
                    target="_blank"
                    className="pocket-guides__download-btn pocket-guides__download-btn--small"
                    rel="noreferrer">
                    Download
                  </a>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  render() {
    const {
      pocketGuides,
      filteredGuides,
      formSubmitted,
      hideTable,
      selectedCount,
      handleDownload,
    } = this.props;

    if (hideTable) {
      return null;
    }

    return (
      <div className="pocket-guides__table-wrapper">
        <div className="m-fl ai-c jc-sb pocket-guides__table-header-wrapper">
          <p className="pocket-guides__table-header">Technical Pocket Guides</p>
          <p className="pocket-guides__table-text">
            Displaying Pocket Guides
            <b>
              {' '}
              {!formSubmitted
                ? pocketGuides.length
                : filteredGuides.length}{' '}
            </b>
            in total
          </p>
        </div>

        {!formSubmitted
          ? this.renderDownloadTable()
          : this.renderDownloadLinks()}
        {!formSubmitted && (
          <NiceicDownloadButton
            handleDownload={handleDownload}
            isDisabled={selectedCount > 0 ? false : true}
          />
        )}
      </div>
    );
  }
}

export default NiceicPocketGuidesTable;
